import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { SITE } from "@/content/site";

export const WhatsAppFab = () => {
  const { t } = useLang();
  if (!SITE.whatsappHref) return null;
  return (
    <motion.a
      href={SITE.whatsappHref} target="_blank" rel="noopener noreferrer" data-testid="whatsapp-fab" aria-label={t.common.whatsapp}
      initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ delay: 1.6, type: "spring", stiffness: 260, damping: 20 }}
      whileHover={{ scale: 1.06 }} whileTap={{ scale: 0.95 }}
      className="group fixed bottom-5 end-5 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#1E3A5F] text-white ring-1 ring-white/20 sm:bottom-8 sm:end-8"
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6" fill="currentColor" aria-hidden="true">
        <path d="M12.04 2a9.9 9.9 0 0 0-8.5 15l-1.4 5 5.2-1.36A9.93 9.93 0 1 0 12.04 2Zm0 18.1a8.2 8.2 0 0 1-4.18-1.15l-.3-.18-3.08.8.82-3-.2-.31a8.2 8.2 0 1 1 6.94 3.84Zm4.5-6.14c-.25-.12-1.46-.72-1.69-.8-.23-.08-.39-.12-.55.12-.17.25-.64.8-.78.97-.14.16-.29.18-.53.06a6.7 6.7 0 0 1-3.32-2.9c-.25-.43.25-.4.72-1.33.08-.16.04-.3-.02-.43-.06-.12-.55-1.33-.76-1.82-.2-.48-.4-.41-.55-.42h-.47a.9.9 0 0 0-.65.3 2.74 2.74 0 0 0-.86 2.04 4.76 4.76 0 0 0 1 2.53 10.9 10.9 0 0 0 4.17 3.68c1.55.67 2.16.73 2.93.61.47-.07 1.46-.6 1.67-1.17.2-.58.2-1.07.14-1.17-.06-.1-.22-.17-.47-.29Z" />
      </svg>
      <span className="pointer-events-none absolute end-full me-3 whitespace-nowrap bg-[#0F2138] px-3 py-2 text-xs text-white opacity-0 transition-opacity duration-300 group-hover:opacity-100">{t.common.whatsapp}</span>
    </motion.a>
  );
};
